import { render, staticRenderFns } from "./lssy2.vue?vue&type=template&id=5bbca73a&scoped=true"
import script from "./lssy2.vue?vue&type=script&lang=js"
export * from "./lssy2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbca73a",
  null
  
)

export default component.exports